<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Suas compras concretizadas via avaliação"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getContent"
    labelCard="Comprado por"
    buyerScope="AnnouncementCompleted"
    noVehicleLabel="Você ainda não avaliou nenhum veículo…"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";
import BuyerOneColumnPage from "../../BuyerOneColumnPage";
import { getBuyerContent } from "@/helpers/getContent";

export default {
  name: "AnnouncementCompletedPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title: "Compras concretizadas - Avaliações",
      section: "Encerrados",
    };
  },
  methods: {
    async getContent(orderBy, period, page = 1 ) {
      const plate = this.$route?.query?.plate || null;

      return await getBuyerContent({
        type: "announcementCompleted",
        plate,
        orderBy,
        period,
        page,
      });
    },
  },
};
</script>

<style scoped></style>
